import { Store } from "vuex";
import Router from "vue-router";
import Vue from "vue";

export let $storeRef: Store<any>;
export let $authUrl: string;
export let $routerRef: Router;
export default {
  install(
    vue: Vue,
    dep: { router: Router; store: Store<any>; authUrl: string }
  ) {
    if (!dep.router) {
      throw Error("Missing router dependency");
    }
    if (!dep.store) {
      throw Error("Missing store dependency");
    }
    if (!dep.authUrl) {
      throw Error("Missing authUrl dependency");
    }
    $storeRef = dep.store;
    $routerRef = dep.router;
    $authUrl = dep.authUrl;
    dep.router.addRoutes(require("./routes").default);
    dep.store.registerModule("auth", require("./store/auth.module").default);
  }
};
